import { LocalStorageKeys } from 'app/shared/constants/localStorage';

const validJSON = (strInput) => {
  try {
    return JSON.parse(strInput);
  } catch {
    return null;
  }
};

export const getLocalStorageJSON = (key: LocalStorageKeys): unknown => {
  const item = localStorage.getItem(key);
  return validJSON(item);
};
